import styled from "styled-components";
import Layout_user from "../../../Component/UI/Layout_user";
import TopBar from "../../../Component/UI/TopBar";
import { useEffect, useState } from "react";
import {
  CheckBox,
  Icon,
  RowView,
  RowView2,
} from "../../../Component/style/common_style";
import SearchAddrApi from "./Modal/SearchAddrApi";
import nick_dup_check from "../../../Component/tool/duplicate_check";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import url from "../../../Component/server";

const SignUp = () => {
  const Navigate = useNavigate();
  const { state } = useLocation();
  const go_rule = () => window.open("/rule/1", "_blank", "noopener,noreferrer");
  const go_rule2 = () =>
    window.open("/rule/2", "_blank", "noopener,noreferrer");

  // 아이디
  const [userId, setUserId] = useState("");

  // 닉네임
  const [nickname, setNickname] = useState("");
  const [nickCheck, setNickCheck] = useState(false);

  const handleNickname = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    if (input.includes(" ")) {
      alert("닉네임에 공백은 사용할 수 없습니다.");
      return;
    }
    setNickname(e.target.value);
    nickCheck && setNickCheck(false);
  };

  const NicknameCheck = async () => {
    if (nickname === "") {
      alert("닉네임을 입력해주세요");
      return;
    }
    const isCheck = await nick_dup_check(nickname);

    if (isCheck === "err") {
      setNickCheck(false);
      return;
    } else if (isCheck) {
      setNickCheck(true);
      alert("사용 가능한 닉네임 입니다.");
    } else {
      setNickCheck(false);
      alert("이미 존재하는 닉네임 입니다.");
    }
  };

  // 이름
  const [userName, setUserName] = useState("");
  const handleUserName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setUserName(input);
  };

  // 연락처
  const [phoneNum, setPhoneNum] = useState("");
  const handlePhoneNum = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setPhoneNum(input);
  };

  // 주소
  const [postCode, setPostCode] = useState("");
  const [firAddr, setFirAddr] = useState("");
  const [secAddr, setSecAddr] = useState("");

  const handlePostCode = (data: string) => {
    setPostCode(data);
  };
  const handleFirAddr = (data: string) => {
    setFirAddr(data);
  };
  const handleSecAddr = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setSecAddr(input);
  };

  // 약관 동의
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);

  const handleCheck1 = () => {
    setCheck1(!check1);
  };
  const handleCheck2 = () => {
    setCheck2(!check2);
  };

  // 주소검색
  const openSearchAddr = () => {
    SearchAddrApi({ setFirAddr, setPostCode });
  };

  useEffect(() => {
    if (state) {
      setUserId(state.userid);
      setUserName(state.name);
      setPhoneNum(state.phone);
      return;
    }
    Navigate("/");
  }, []);

  // 회원가입
  const isOk =
    [nickname, userName, phoneNum, postCode, firAddr, secAddr].every(Boolean) &&
    check1 &&
    check2 &&
    nickCheck
      ? // && check2
        true
      : false;

  const join_API = () => {
    if (!isOk) {
      return;
    }
    if (!nickCheck) {
      alert("닉네임 중복검사를 해주세요.");
      return;
    }

    axios
      .post(
        url.Communication_url.user_join,
        {
          userid: userId,
          name: userName,
          nickname: nickname,
          phone: phoneNum.replaceAll("-", ""),
          addr_num: postCode,
          addr_basic: firAddr,
          addr_detail: secAddr,
          terms_agree: "y",
          privacy_agree: "y",
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((res) => {
        // console.log(res.data);
        if (res.data === "성공") {
          login_API();
        } else if (res.data === "오류") {
          alert("이미 가입된 회원입니다.");
        }
      })
      .catch((err) => {
        const errRes = err.response.data;
        if (errRes.message) {
          return alert(errRes.message);
        }
        console.error(errRes);
      });
  };

  const login_API = () => {
    axios
      .post(
        url.Communication_url.user_login,
        {
          userid: userId,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((res) => {
        const userinfo = res.data;
        if (userinfo.accessToken) {
          const token_refresh = userinfo.refreshToken;
          localStorage.setItem("key", token_refresh);
          Navigate("/");
        }
      })
      .catch((err) => {
        const errRes = err.response.data;
        if (errRes.message) {
          return alert(errRes.message);
        }
        console.error(errRes);
      });
  };

  return (
    <Layout_user background="white">
      <div style={{ padding: 15 }}>
        <TopBar title={"회원정보"} color={"white"} />
        <TitleDiv>
          닉네임 <span style={{ color: "red" }}>*</span>
        </TitleDiv>
        <NicknameDiv>
          <NicknameInsertDiv>
            <NicknameInsert
              type="text"
              placeholder="무통장 입금시 필요해요."
              value={nickname}
              onChange={handleNickname}
              // onKeyDown={(e) => {
              //   if (e.key === "Enter") {
              //     // 닉네임 중복확인
              //     NicknameCheck();
              //   }
              // }}
            />
          </NicknameInsertDiv>
          <NicknameCheckBtn onClick={NicknameCheck}>중복확인</NicknameCheckBtn>
        </NicknameDiv>
        <div
          style={{
            marginTop: 10,
            color: "#EB003B",
            width: "70%",
            marginLeft: 23,
          }}
        >
          닉네임은 한글, 숫자 2~8자로 입력해주세요.(특수문자, 공백 사용 불가능)
        </div>

        <TitleDiv>
          이름 <span style={{ color: "red" }}>*</span>
        </TitleDiv>
        <InsertDiv>
          <InsertInput
            type="text"
            placeholder="이름을 입력해주세요."
            value={userName}
            onChange={handleUserName}
          />
        </InsertDiv>
        <TitleDiv>
          연락처 <span style={{ color: "red" }}>*</span>
        </TitleDiv>
        <InsertDiv>
          <InsertInput
            type="number"
            placeholder="- 를 제외한 연락처를 입력해주세요."
            value={phoneNum}
            onChange={handlePhoneNum}
          />
        </InsertDiv>
        <TitleDiv>
          주소 <span style={{ color: "red" }}>*</span>
        </TitleDiv>
        <PostCodeDiv>
          <PostCodeInsertDiv>
            <PostCodeInsert
              disabled
              type="text"
              placeholder="우편번호"
              value={postCode}
            />
          </PostCodeInsertDiv>
          <PostCodeSearchBtn onClick={openSearchAddr}>검색</PostCodeSearchBtn>
        </PostCodeDiv>
        <InsertDiv>
          <InsertInput
            disabled
            type="text"
            placeholder="주소"
            value={firAddr}
          />
        </InsertDiv>
        <InsertDiv>
          <InsertInput
            type="text"
            placeholder="상세주소를 입력해주세요."
            value={secAddr}
            onChange={handleSecAddr}
          />
        </InsertDiv>
        <TermsDiv>
          <RowView>
            <RowView2>
              <CheckBox
                type={"checkbox"}
                checked={check1}
                readOnly
                onClick={handleCheck1}
              />
              [필수] 서비스 이용약관 동의
            </RowView2>
            <DetailBtn onClick={go_rule}>
              보기
              <Icon src={require("../../../Image/ic_right_gray.png")} />
            </DetailBtn>
          </RowView>
          <RowView style={{ marginTop: 10 }}>
            <RowView2>
              <CheckBox
                type={"checkbox"}
                checked={check2}
                readOnly
                onClick={handleCheck2}
              />
              [필수] 개인정보 처리 방침 동의
            </RowView2>
            <DetailBtn onClick={go_rule2}>
              보기
              <Icon src={require("../../../Image/ic_right_gray.png")} />
            </DetailBtn>
          </RowView>
        </TermsDiv>

        <SaveBtn onClick={join_API} $isOk={isOk}>
          저장하기
        </SaveBtn>
      </div>
    </Layout_user>
  );
};

export default SignUp;

const TitleDiv = styled.div`
  font-size: 16px;
  font-family: var(--font-Pretendard-Medium);
  margin-top: 30px;
`;

const NicknameDiv = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
`;

const NicknameInsertDiv = styled.div`
  flex-direction: row;
  display: flex;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  flex: 7;
  height: 50px;
  justify-self: center;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
`;

const NicknameInsert = styled.input`
  margin-left: 4px;
  font-size: 16px;
  color: black;
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
`;

const NicknameCheckBtn = styled.div`
  cursor: pointer;
  background-color: black;
  height: 48px;
  border-radius: 8px;
  flex: 2;
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: var(--font-Pretendard-Medium);
  color: white;
`;

const InsertDiv = styled.div`
  flex-direction: row;
  display: flex;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  width: 100%;
  height: 50px;
  justify-self: center;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
  margin-top: 10px;
`;

const InsertInput = styled.input`
  margin-left: 4px;
  font-size: 16px;
  color: black;
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
  /* 화살표 제거 - Chrome, Safari, Edge */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* 화살표 제거 - Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

const PostCodeDiv = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
`;

const PostCodeInsertDiv = styled.div`
  flex-direction: row;
  display: flex;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  flex: 5;
  height: 50px;
  justify-self: center;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
`;

const PostCodeInsert = styled.input`
  margin-left: 4px;
  font-size: 16px;
  color: black;
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
`;

const PostCodeSearchBtn = styled.div`
  cursor: pointer;
  background-color: black;
  height: 48px;
  border-radius: 8px;
  flex: 1;
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: var(--font-Pretendard-Medium);
  color: white;
`;

const TermsDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
`;

const DetailBtn = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #8e8e8e;
  cursor: pointer;
`;

const SaveBtn = styled.div<{ $isOk: boolean }>`
  display: flex;
  margin-top: 40px;
  width: 100%;
  height: 48px;
  background: ${(props) =>
    props.$isOk ? "linear-gradient(135deg, #7955f0, #3209b9)" : "#f8f8f8"};

  border-radius: 8px;
  color: ${(props) => (props.$isOk ? "white" : "#8e8e8e")};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: var(--font-Pretendard-SemiBold);
`;
